<template>
  <div>
    <el-button v-if="showBtns" @click="handleEdit()" size="mini" type="success"  icon="el-icon-edit">{{label||$t('编辑代码')}}</el-button>
    <l-dialog :title="title" :visible.sync="editingVisible" :height="528" :width="1000" v-el-drag-dialog
      @ok="handleCodeSave" @opened="handleOpenedForm" @close="handleCloseForm">
      <l-layout :right="320">
        <l-code-mirror v-model="editingCode" isHint :handleHint="handleHint" :mode="mode"></l-code-mirror>
        <template #right>
          <div class="l-rblock" style="padding:8px;overflow: auto;">
            <el-alert title="程序脚本说明,支持ES5语法" type="warning" :closable="false">
              <div v-html="alertString"></div>
            </el-alert>
          </div>
        </template>
      </l-layout>
    </l-dialog>
  </div>
</template>
<script>

export default {
  name: 'l-codeeditor',
  props: {
    label: String,
    visible: {
      type: Boolean,
      default: false
    },
    width: {
      type: [String, Number],
      default: 600
    },
    height: {
      type: Number,
      default: 400
    },
    top: {
      type: [Number, String],
      default: 10
    },
    theme: {
      type: String,
      default: 'default' // dark
    },
    mode: {
      type: String,
      defualt: 'application/javascript'
    },
    alertString: {
      type: String,
      defualt: ''
    },
    showBtns: {
      type: Boolean,
      defualt: true
    },
    Hints: {
      type: Array,
      default: () => { return [] }
    },
    value: String,
  },
  watch: {

  },
  data() {
    return {      
      editingCode: '',
      editingVisible: false,
      oldSearch: ''
    };
  },
  mounted() {
  },
  computed: {
    visible2: {
      get() {return this.visible},
      set(val) { this.visible = val}
    },
    value2: {
      get() {
        return this.value || ''
      },
      set(val) {
        this.$emit('input', val)
      }
    }
  },
  methods: {
    handleEdit() {
      this.open()
    },
    open() {
      this.editingVisible = true
    },
    handleCloseForm() {
      this.editingCode = ''
    },
    handleCodeSave() {
      this.value2 = this.editingCode
      this.editingVisible = false
    },
    handleOpenedForm() {
      this.editingCode = this.value2
    },
    handleHint(cursor, token) {
      var text = token.string;
      text = text.replace(/'/g, '')
      text = text.replace(/"/g, '')
      if (text == '.') {
        text = this.oldSearch + text;
        return this.Hints.filter(t => t.startsWith(text)).map(t => t.replace(text, '.'))
      } else {
        this.oldSearch = text;
      }
      return this.Hints.filter(t => !t.startsWith('$this.') && !t.startsWith('$p.') && t.indexOf(text) != -1)
    }
  }
}
</script>
<style lang="less">
@import './index.less';
</style>
